import { withPerformanceApp } from './performance'
import withI18n from './withI18n'
import withRedux from './withRedux'
import withCtx from './withCtx'
import { withExportCompatibility } from './withExportCompatibility'
import withPrefetchApi from './withPrefetchApi'
import withRoot from './withRoot'

export function wrapApp(App, option) {
  const middleWares = [
    // 注意包装顺序
    withCtx, // 必须在最前
    withRedux,
    withI18n,
    withPrefetchApi,
    withPerformanceApp,
    withRoot, // 必须在最末
    withExportCompatibility, // 额外的必须放在最末
  ]

  let TargetApp = App
  for (const m of middleWares.reverse()) {
    // 生效顺序与包装顺序相反
    TargetApp = m(TargetApp, option)
  }
  return TargetApp
}
